import { useLingui } from '@lingui/react/macro';
import classNames from 'classnames';
import { CHAT_ERROR_MESSAGES } from 'modules/chat/domain/constants';
import { ChatRole } from 'modules/chat/domain/enums/chat-role';
import { ChatMessage } from 'modules/chat/domain/interfaces';
import React from 'react';
import { theme } from 'styles/theme/theme';
import { UDText } from 'ud-ui/components';
import ChatConfirmationCard from './chat-confirmation-card';

interface Props {
  message: ChatMessage;
  confirmBusy?: boolean;
  onConfirm?: () => Promise<void>;
  onCancel?: () => Promise<void>;
}

const ChatMessageItem: React.FC<Props> = ({ message, confirmBusy = false, onConfirm, onCancel }) => {
  const { t } = useLingui();
  const isUser = message.role === ChatRole.USER;
  const confirmation = message.pendingConfirmation;
  const content = message.errorCode ? t(CHAT_ERROR_MESSAGES[message.errorCode]) : message.content;

  return (
    <div className={classNames('flex w-full', isUser ? 'justify-end' : 'justify-start')}>
      <div
        className="max-w-[75%] rounded-lg px-4 py-2 whitespace-pre-wrap"
        style={{ backgroundColor: isUser ? theme.colors.LightBlue : theme.colors.SurfaceCultured10 }}
      >
        <UDText type="body-text" color={isUser ? theme.colors.SurfaceWhite : theme.colors.Black}>
          {content}
        </UDText>
        {confirmation && onConfirm && onCancel && (
          <ChatConfirmationCard
            confirmation={confirmation}
            disabled={confirmBusy}
            onConfirm={onConfirm}
            onCancel={onCancel}
          />
        )}
      </div>
    </div>
  );
};

export default React.memo(ChatMessageItem);
